/**
 * academyFocus, tiny helper that tracks "Deep Focus" study sessions.
 * Focus Mode = the learner has hidden the site menu inside the Academy.
 * When a lesson is completed while Focus Mode is active, we grow a per-child
 * "focus streak" and celebrate milestones. All state lives in localStorage
 * so it survives reloads; everything is best-effort and never throws.
 */

const ACTIVE_KEY = "academy_focus_active";
const streakKey = (childId) => `academy_focus_streak_${childId || "self"}`;

export function setFocusActive(active) {
  try {
    localStorage.setItem(ACTIVE_KEY, active ? "1" : "0");
  } catch (_) { /* ignore */ }
}

export function isFocusActive() {
  try {
    return localStorage.getItem(ACTIVE_KEY) === "1";
  } catch (_) {
    return false;
  }
}

export function getFocusStreak(childId) {
  try {
    return parseInt(localStorage.getItem(streakKey(childId)) || "0", 10) || 0;
  } catch (_) {
    return 0;
  }
}

/**
 * Call when a lesson is completed. If Focus Mode is active, increments and
 * returns the new streak count; otherwise returns null (no celebration).
 */
export function recordFocusLessonComplete(childId) {
  if (!isFocusActive()) return null;
  try {
    const next = getFocusStreak(childId) + 1;
    localStorage.setItem(streakKey(childId), String(next));
    return next;
  } catch (_) {
    return null;
  }
}
